module.exports={GLOBAL_CONFIG:"Ajustes generales",SUBMIT_TRANSACTION_AFTER_AUTO_APPROVAL:"Enviar transacciones tras aprobación automática"};